var _jsxFileName = "/opt/atlassian/pipelines/agent/build/src/components/connection/Partner/browser/PumpConnectionState/index.tsx";
import React from 'react';
import { connect } from 'react-redux';
import { IconStatusCorrect, IconStatusIncorrect, InformationalScreen, Stack, Text } from '@adc/parallax-component-library';
import { Main } from 'Components/utility';
import { ThemedImage } from 'Components/utility/ThemedImage';
import i18n from 'Utilities/i18n';
const mapStateToProps = ({
  env: {
    state,
    pName
  }
}) => {
  return {
    state,
    pName
  };
};
const connector = connect(mapStateToProps);
const PumpConnectionState = ({
  state,
  pName
}) => {
  const StatusProps = {
    success: {
      icon: IconStatusCorrect,
      title: i18n.t('BrowserStates.content.success.primaryText'),
      subtitle: i18n.t('BrowserStates.content.success.secondaryText')
    },
    error: {
      icon: IconStatusIncorrect,
      title: i18n.t('BrowserStates.content.error.primaryText'),
      subtitle: i18n.t('BrowserStates.content.error.secondaryText', {
        pumpPartner: pName
      })
    }
  };
  const PageData = StatusProps[state || 'success'] ?? StatusProps.error;
  return /*#__PURE__*/React.createElement(Main, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 47,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(InformationalScreen, {
    topNavigationProps: {
      animatedTitle: true,
      logo: /*#__PURE__*/React.createElement(ThemedImage, {
        resourceKey: "Global.microcopy.common.libreLogoLight",
        testID: "Libre.logo",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 52,
          columnNumber: 13
        }
      })
    },
    testID: "BrowserStates",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 48,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(InformationalScreen.Page, {
    backgroundColor: "$surface.container",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 57,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(InformationalScreen.Content, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 58,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(Stack, {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginTop: "$10",
    padding: "$4",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 59,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement(PageData.icon, {
    size: "XL",
    scale: 1,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 66,
      columnNumber: 15
    }
  }), /*#__PURE__*/React.createElement(Text, {
    testID: "BrowserStates.primaryText",
    marginTop: "$10",
    color: "$text.100",
    fontSize: "$h2.strong",
    fontWeight: "$h2.strong",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 67,
      columnNumber: 15
    }
  }, PageData.title), /*#__PURE__*/React.createElement(Text, {
    textAlign: "center",
    color: "$text.100",
    fontSize: "$bodyBase.default",
    fontWeight: "$bodyBase.default",
    marginTop: "$2",
    testID: "BrowserStates.secondaryText",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 76,
      columnNumber: 15
    }
  }, PageData.subtitle))))));
};
export default connector(PumpConnectionState);